import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/shared/components/Component";
import Page from "src/shared/components/Page";
import withAppContext from "src/shared/components/withAppContext";
import withAxios from "src/shared/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { styles } from "./styles";
import { IProps, IStripeSucessPurchaseState } from "./types";
import LoadingSpinner from "src/shared/components/LoadingSpinner";
import { FILE_URL, PAYMENT_TITLE } from "src/constants";

export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(

        class extends Component<IProps, IStripeSucessPurchaseState> {
          public readonly state = this.buildState({
            loader: false,
            upgradeDetails: {},
            paymentDetails: {},
            openAgreement: false,
            paymentMethodType: 0,
            isAgree: false,
            subscriptionPlan: {},
            sessionId: "",
            resPaymentConfirm: null,
            inVoiceUrl: ""

          });
          // public handlePopState: (event: any) => void;
          public componentDidMount() {
            this.getUpgradeDetails()
            window.history.pushState(null, "", window.location.href);

            // this.handlePopState = (event) => {
            //     // Prevent back button by pushing a new entry again
            //     window.history.pushState(null, "", window.location.href);
            // };

            // Add an event listener to detect back button navigation
            // window.addEventListener('popstate', this.handlePopState);
        }
        public handleBackButton = (event: PopStateEvent) => {
            console.log(event, "EVENT====>?")
        };
        public componentWillUnmount() {
            // window.removeEventListener('popstate', this.handlePopState);
        }
          public getUpgradeDetails = () => {
            this.setState({ sessionId: "" })
            const storedObject: string = localStorage.getItem("upgradeDetails") || '{}';  // Fallback to an empty object string
            const parsedObject = JSON?.parse(storedObject);
            if (Object.keys(parsedObject).length > 0) {
              this.setState({ upgradeDetails: parsedObject }, () => {
                this.setState({ sessionId: parsedObject?.stripeRes?.stripe_session_id }, () => {
                  this.paymentConfirm()
                })
                this.getAllPlanHandler()

              })
            }
          }


          public async getAllPlanHandler() {
            this.setState({ loader: true })
            const planId: any = this.state.upgradeDetails?.plan?.id
            const addonPlan = this.state.upgradeDetails?.addon?.length > 0 ? this.state.upgradeDetails?.addon.map((itm: any) => itm.id) : []

            const addonId: any = addonPlan || []
            const paymentData = {
              // "payment_method":"cheque",
              "plan_id": planId,
              "addon_id": addonId,
              "membership_id": this.state?.upgradeDetails?.membership_id || ""
            }

            const res: any = await this.buildPost(this, "payment/planPayNow")(paymentData)
            if (res.status && Object.keys(res?.data)?.length > 0) {
              this.setState({ paymentDetails: { ...res?.data, addon: res?.data?.addon == null ? [] : res?.data?.addon, plan: res?.data?.plan != null ? res?.data?.plan : {} } }, () => {
                console.log("paymentDetails======>", this.state.paymentDetails)
              })
              this.setState({ loader: false })
            } else {
              this.setState({ loader: false })
            }

          }
          public paymentConfirm = async () => {
            const { sessionId } = this.state
            if (sessionId) {
              const paymentData = {
                "stripe_session_id": sessionId,
              }
              const resPaymentConfirm: any = await this.buildPost(this, "payment/paymentConfirm")(paymentData)
              console.log("resPaymentConfirm=========>", resPaymentConfirm)
              if (resPaymentConfirm?.status) {
                this.setState({ resPaymentConfirm }, () => {
                  this.InvoiceDownload()
                })
              }
            }
          }
          public InvoiceDownload = async () => {
            const InvoiceId = this.state.resPaymentConfirm?.data?.id
            if (InvoiceId) {
              const resInvoice: any = await this.buildGet(this, `payment/invoice/${InvoiceId}`)()
              console.log("resInvoice======>", resInvoice)
              if (resInvoice?.status) {
                const InvoiceUrlObject = resInvoice?.data?.result_data || {}
                const InvoiceURL = JSON.parse(InvoiceUrlObject)?.invoice
                const InvoicNumber = JSON.parse(InvoiceUrlObject)?.invoiceNumber
                this.setState({ inVoiceUrl: { url: FILE_URL + "/" + InvoiceURL, name: InvoicNumber + ".pdf" } })

              }
            }

          }
          public TwoDecimalFloat(amount: any) {
            const valueAnount = amount;
            const roundedNumber = valueAnount.toFixed(2);
            return roundedNumber

          }


          public render() {
            const {
              appContext: { user, baseUri },
              classes,
            } = this.props;
            console.log(user, classes, baseUri)

            return (


                <div>
              {this.state.loader &&<div className="loader-bg-color">
                <LoadingSpinner /></div>}
              <Page
                header={'Subscription Upgrade'}
                subtitle={''}
              >
                <div>
                  <div className="container">
                    <div className="purchase-content">
                      <div className="row purchase-row">
                        <div className="col-lg-8">
                          {Object.keys(this.state?.paymentDetails)?.length > 0 && <div className="purchase-inner-content">
                            <div className="purchase-inform"><h3>{PAYMENT_TITLE}</h3></div>
                            {Object?.keys(this.state?.paymentDetails?.plan)?.length > 0 && <div className="subscription-fee">
                              <div className="subscription-fee-flex">
                                <div className="sub-yearly">
                                  <h4>Subscription {this.state?.paymentDetails?.plan?.id === 1 ? "Fee" : "Fees"} <br />
                                    ({this.state?.paymentDetails?.plan?.title}/{this.state?.paymentDetails?.plan?.payment_frequency_type.charAt(0).toUpperCase() + this.state?.paymentDetails?.plan?.payment_frequency_type.slice(1)})</h4>
                                </div>
                                <div>
                                  <h3> ${this.TwoDecimalFloat(this.state?.paymentDetails?.plan?.price)}</h3>
                                </div>
                              </div>
                            </div>}
                            {this.state?.paymentDetails?.addon?.length > 0 && this.state?.paymentDetails?.addon.map((item: any) => {
                              return (
                                <div className="customizeable" key={item?.id}>
                                  <div className="subscription-sub-flex">
                                    <div className="sub-custom">
                                      <h4>{item?.title}
                                        <br />
                                        (Add on) </h4>
                                    </div>
                                    <div>
                                      <h3>${this.TwoDecimalFloat(item?.price)}</h3>
                                    </div>
                                  </div>
                                </div>
                              )

                            })
                            }
                            <div className="totalprice"><h3>Total: ${this.TwoDecimalFloat(this.state?.paymentDetails?.total)}</h3></div>
                            <>
                              <div

                              >
                                <button className="down-invoice" >
                                  <a href={this.state.inVoiceUrl?.url} download={this.state.inVoiceUrl?.name} style={{ color: 'white' }} target="_blank">
                                    Download Invoice
                                  </a>
                                </button>
                              </div>
                              <div>
                                <button className="down-invoice" onClick={() => {
                                  this.props.history.push(`/${this.props.school?.slug}/dashboard`)
                                }}>
                                  Back to Dashboard
                                </button>
                              </div>
                            </>

                          </div>}

                        </div>

                      </div>
                    </div>

                  </div>

                </div>
              
              </Page>
              </div>
            );
          }


        }

      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/upgradeSubscription/stripePaymentSucess.tsx